import { VideoButtonProps } from './Types'
import { track } from '@tldraw/tldraw'
import { ToolbarButton } from '../../components/ToolbarButton'
import { AlignVerticalCenter } from 'blaze-ui/icons'
import { fitAndPositionShape } from './helpers'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const FitButton = track(({ editor, selectedShape }: VideoButtonProps) => {
  const { isMobile } = useResponsiveDesign()
  const handlePress = () => {
    fitAndPositionShape(editor, selectedShape, 'contain')
  }

  return (
    <ToolbarButton frontIcon={AlignVerticalCenter} onPress={handlePress}>
      {!isMobile && 'Fit to Canvas'}
    </ToolbarButton>
  )
})

export { FitButton }
